'use strict';

document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.video-wrapper');

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                const wrapper = entry.target;
                const video = wrapper.querySelector('video');
                const playPauseIcon = wrapper.querySelector('.play-pause-icon');

                const playIcon = wrapper.dataset.playIcon;
                const pauseIcon = wrapper.dataset.pauseIcon;

                if (entry.isIntersecting) {
                    if (video.hasAttribute('autoplay')) {
                        video.play().catch(() => {});
                        playPauseIcon.src = pauseIcon;
                    }
                } else {
                    video.pause();
                    playPauseIcon.src = playIcon;
                }
            });
        },
        { threshold: 0.5 }
    );

    wrappers.forEach(wrapper => {
        const video = wrapper.querySelector('video');
        const playPauseBtn = wrapper.querySelector('.video-toggle-btn');
        const muteBtn = wrapper.querySelector('.video-sound-btn');
        const playPauseIcon = wrapper.querySelector('.play-pause-icon');
        const soundIcon = wrapper.querySelector('.soundIcon');

        const playIcon = wrapper.dataset.playIcon;
        const pauseIcon = wrapper.dataset.pauseIcon;
        const muteIcon = wrapper.dataset.muteIcon;
        const unmuteIcon = wrapper.dataset.unmuteIcon;

        // Play / Pause toggle
        playPauseBtn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playPauseIcon.src = pauseIcon;
            } else {
                video.pause();
                playPauseIcon.src = playIcon;
            }
        });

        // Mute / Unmute toggle
        muteBtn.addEventListener('click', () => {
            video.muted = !video.muted;
            soundIcon.src = video.muted ? muteIcon : unmuteIcon;
        });

        // Observe for viewport autoplay
        observer.observe(wrapper);
    });
});
